/**
 * Panel Name: Stock Item 
 * App Name: WalmartWeb
 * Created Date:10/20/2021
 * Author:Aparna.K
 * */

/**
 * STK_PS_01
 * import ItemMaintenanceAAction, ItemMaintenanceAStore,sdiconstants,jquery
 * */
import React, { Component } from 'react';
import * as ItemMaintenanceAAction from '../actions/ItemMaintenanceAAction';
import ItemMaintenanceAStore from '../stores/ItemMaintenanceAStore';
import * as CookieService from '../CookieService';
import SDIConstants from '../SDIConstants';
import * as $ from 'jquery';
import { withTranslation, Trans } from 'react-i18next'
import i18n from '../i18n';
//import { Select } from "react-select-virtualized";
/**
 * for npm searchable dropdown
 * */

import Select from 'react-select'
//import Autosuggest from 'react-autosuggest'
//import { FixedSizeList as List } from "react-window";
//import { WindowSelect } from 'react-window-select'
import WindowedSelect from "react-windowed-select";
import Autocomplete from 'react-autocomplete';
/***
 * for favorite icon
 * */
import * as MenuAction from '../actions/MenuAction';
import swal from 'sweetalert';
/**
 * CPW-94_PC_02
 * Aparna
 * */
import * as NonCatalogAction from '../actions/NonCatalogAction';
import NonCatalogStore from '../stores/NonCatalogStore';
import ItemDetailNewStore from '../stores/ItemDetailNewStore';
import * as ItemDetailNewAction from '../actions/ItemDetailNewAction';
import { minWidth } from '@material-ui/system';
let currentPagePath;
const queryParams = new URLSearchParams(window.location.search)
let rmvAttachindex = -1;//CPW-94_PC_02 -Aparna
const options = [];
const App = () => <Select components={{ ItemMaintenanceAComponent }} options={options} />;

class ItemMaintenanceAComponent extends Component {
    /**
       * Ref: STK_PC_02
       * Set the initial values of the state variables
       */
    constructor(props) {

        super(props);
        /**
         * CPW-94_PC_04
         * Aparna
         * */
        this.addAttachementResponse = this.addAttachementResponse.bind(this)
        this.removeAttachmentResponse = this.removeAttachmentResponse.bind(this)
        this.bindAttachments = this.bindAttachments.bind(this)
        this.validateMfg = this.validateMfg.bind(this)
        this.validateMfgResponse = this.validateMfgResponse.bind(this)
        this.AnykeyPress = this.AnykeyPress.bind(this);
        /**
       * Ref: STK_PC_03
       * Set the initial values of the state variables
       */
        this.state = {
            ItemId: "NEXT",
            UMO: [], SelectedUMO: "",
            UtilizationType: [], SelectedUtilizationType: "",
            shipBU: [], SelectedShipBU: "",
            Category: [], SelectedCategory: "",
            ProductGroup: "",
            Description: "",
            Notes: "",
            Manufacturer: [], SelectedManufacturer: "",
            MfgPart: "",
            SuggestedSupplier: "",
            Replenish: false, CriticalSpare: false,
            MinQtyOnHand: "",
            MaxQty: "",
            ChargeCD: [], SelectedChargCD: "",
            EmpId: [], SelectedEmpId: "",
            HazardCD: [], SelectedHazardCD: "",
            MSDS: "",
            Inceptionrequired: false,
            Regraind: false,
            FirstChargeCD: "",
            ETAG: "",
            PDS: "",
            DrawingCD: "",
            MachineCtrlNo: "",
            BinLocation: [],
            Area: [], SelectedArea: "",
            Aisle: [], SelectedAisle: "",
            Row: [], SelectedRow: "",
            Shelf: [], SelectedShelf: "",
            Bin: [], SelectedBin: "",
            Noun: [], SelectedNoun: "",
            ItemType: [], SelectedItemType: "",
            StockType: [], SelectedStockType: "",
            Modifier: [], SelectedModifier: "", ModifyArr: [],
            LeadTime: "",
            VendorId: [], SelectedVendorId: "",
            VendorItemId: "",
            StdCD: "",
            ErrNoun: false, ErrItem: false, ErrCat: false, ErrDes: false, ErrMfgPart: false, ErrMfg: false, ErrArea: false, ErrAisel: false,
            ErrRow: false, ErrShelf: false, ErrModifier: false, ErrStdCost: false, ErrVendorId: false, ErrBin: false, ErrEmpId: false,
            isFavorited: false, Price: "", ErrPrice: false, ErrVendorItemID: false, AttachmentPathArrImg: [], ErrMinQH: false, ErrMaxQty: false, //CPW-94_PC_03 -Aparna
            MfgSuggestions: [], Suggestion: [], focus: false, MFG_ID: ""
        }
    };
    /**
     * STK_PS_04
     * This method will trigger first in this component
     * */

    componentDidMount() {
        CookieService.updateLocalStorageValues("Session_PageName", window.location.pathname);
        let BO = {
            Session_UserID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_COMPANYID: CookieService.getLocalStorageValues("Session_COMPANYID"),
            Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
            Session_CUSTID: CookieService.getLocalStorageValues("Session_CUSTID"),
            Session_ItemMode: CookieService.getLocalStorageValues("Session_ITEMMODE"),
            Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            ACT: "ADD"
        }


        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        ItemMaintenanceAAction.PageLoadAction(BO)
        currentPagePath = this.props.location.pathname;
        currentPagePath = currentPagePath.indexOf("?") >= 0 ? currentPagePath.split("?")[0] : currentPagePath;
        let getFavPageBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            pageURL: currentPagePath.toLowerCase(),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
        };
        ItemMaintenanceAAction.getCurrentFavPage(getFavPageBO);
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        if (CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") == null || CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") == undefined ||
            CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") == "" || CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") == " ") {
            let cribID = CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT");
            if (CookieService.getLocalStorageValues("HideMobility") && CookieService.getLocalStorageValues("HideMobility").toUpperCase() == "TRUE") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "No crib has been selected. Please contact the admin/manager to assign a crib"
                });
                this.props.history.push({
                    pathname: `/homepage`
                });
            }
            else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Please select crib from user profile"
                });
                this.props.history.push({
                    pathname: `/profile`,
                    state: { origin: 'Inventory' }
                });
            }
            return;
        }

        $(`#${SDIConstants.SDILoader}`).removeClass('hide');

        ItemMaintenanceAStore.on("ItemMaintenanceAPageLoad", this.PageLoadResponse.bind(this));
        ItemMaintenanceAStore.on("save", this.SaveButtonclickResponse.bind(this));
        ItemMaintenanceAStore.on('favpage', this.loadFavPageResponse.bind(this));
        ItemMaintenanceAStore.on('updateFavPage', this.updateFavPageResponse.bind(this));
        ItemMaintenanceAStore.on('ValidateMfg', this.validateMfgResponse);
        /**
         * CPW-94_PC_04
         * listener method for attachment
         * Aparna
         * */
        ItemDetailNewStore.on('EditResponse', this.addAttachementResponse);
        NonCatalogStore.on('rmvAttach', this.removeAttachmentResponse);
    }

    loadFavPageResponse = () => {
        let favPageResponse = JSON.parse(ItemMaintenanceAStore.currentFavPageResponse);
        if (favPageResponse.length > 0) {
            favPageResponse = favPageResponse[0];
            this.setState({ isFavorited: true, Page_ID: favPageResponse.PAGE_ID });
        };
    };
    componentWillUnmount() {
        ItemMaintenanceAStore.removeListener("ItemMaintenanceAPageLoad", this.PageLoadResponse.bind(this));
        ItemDetailNewStore.removeListener('EditResponse', this.addAttachementResponse);
        NonCatalogStore.removeListener('updateFavPage', this.removeAttachmentResponse);
        ItemMaintenanceAStore.removeListener('ValidateMfg', this.validateMfgResponse);
    }
    updateFavPageResponse = () => {
        if (ItemMaintenanceAStore.updateFavPageResponse.updateType == 1) {
            let response = JSON.parse(ItemMaintenanceAStore.updateFavPageResponse.responseStr)[0];
            if (response.is_Success == "True") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: true, Page_ID: response.Page_ID });
                MenuAction.toastMessage(1);
            }
        } else {
            let response = JSON.parse(ItemMaintenanceAStore.updateFavPageResponse.responseStr)[0];
            if (response.success == "true") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: false });
                MenuAction.toastMessage(2);
            }
        }
        // this.refreshMenu();
    };
    handleFavorite = (event) => {
        this.setState({ isFavorited: event.target.checked });
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        if (event.target.checked == true) {
            let insertFavPageBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                pageURL: currentPagePath.toLowerCase(),
                pageTitle: "Add Stock Items", //WW-333_PC_02 Add Stock Item Panel has Truck Stock Locations and Needs to be Re-labeled Add Stock Items vs. "Item Maintenance"(1/12/2022) -Aparna
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
            }
            ItemMaintenanceAAction.insertFavPage(insertFavPageBO)
        } else {
            let deleteFavPageBO = {
                Page_ID: this.state.Page_ID
            }
            ItemMaintenanceAAction.deleteFavPage(deleteFavPageBO)
        }
    };


    /*
     * STK_PC_05
     * */

    PageLoadResponse = () => {
        

        let Response = JSON.parse(ItemMaintenanceAStore.PageLoadData);
        let BinLoc = Response.BinLocation;
        //console.log("STKResponse", Response)

        //const locmfg = Response.Manufacturer.reduce(
        //    (result, item) =>
        //        result.set(
        //            item.MFG_ID,
        //            (result.get(item.MFG_ID) || []).concat(item)
        //        ),
        //    new Map()
        //);



        let flag = Response.FlagTable;

        if (flag[0].Alert == true || flag[0].Alert == "True") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: flag[0].Alertmsg
            });
            //   alert(flag[0].Alertmsg);
            this.props.history.push({
                pathname: `\HomePage`,

            });
            window.preventDefault();

            return;

        }/* bug 2318 dropdown values are not displayed Pavithra R*/

        const locvendor = Response.Vendor.reduce(
            (result, item) =>
                result.set(
                    item.VENDOR_ID,
                    (result.get(item.VENDOR_ID) || []).concat(item)
                ),
            new Map()
        );
        let AreaDD = [];
        BinLoc.map((item, index) => {

            let obj = {
                value: item.STORAGE_AREA,
                label: item.STORAGE_AREA
            };
            AreaDD.push(obj);

        })
        let locArea = AreaDD.filter((ele, ind) => ind === AreaDD.findIndex(elem => elem.value === ele.value && elem.label === ele.label))

        //console.log("stkmfg", locM)
        let locUMO = []
        let objumo;
        let umoind = 0
        if (Response.UMO != undefined && Response.UMO != null) {
            Response.UMO.map((val, index) => {
                //if (index == 0) {
                //    let defaultvalue = {
                //        value: "NON",
                //        label: "--Select--"
                //    }
                //    locUMO.push(defaultvalue)
                //} //ww-241 UMO is not an mandetary field
                let localArray = {
                    value: val.UNIT_OF_MEASURE,
                    label: val.DESCR
                }

                locUMO.push(localArray)
            });
            umoind = locUMO.findIndex(id => id.value == "EA")
            objumo = locUMO[umoind]
        }
        let locUtilizationType = []
        let objutil;
        let itemind = 0
        //if (Response.UtilizationType != undefined && Response.UtilizationType != null) {
        //    Response.UtilizationType.map((val, index) => {
        //        //if (index == 0) {
        //        //    let defaultvalue = {
        //        //        value: "NON",
        //        //        label: "--Select--"
        //        //    }
        //        //    locUtilizationType.push(defaultvalue)
        //        //}
        //        let localArray = {
        //            value: val.UTILIZ_CD,
        //            label: val.DESCR
        //        }

        //        locUtilizationType.push(localArray)
        //    });

        //    itemind = locUtilizationType.findIndex(id => id.value == "B") // ***Ticket WW-241 (11/24/2021)***
        //    objutil = locUtilizationType[itemind]
        //}

        let locBU = []
        let objBU;
        let BUind = 0
        if (Response.BU != undefined && Response.BU != null) {
            Response.BU.map((val, index) => {
                let localArray = {
                    value: val.BUSINESS_UNIT, //WW-241 to show the name
                    label: val.DESCR
                }

                locBU.push(localArray)
            });
            //BUind = locBU.findIndex(id => id.value ==CookieService)
            //objutil = UtilizationType[itemtypeind]
        }
        let locCategory = []
        //if (Response.Category != undefined && Response.Category != null) {
        //    Response.Category.map((val, index) => {
        //        if (index == 0) {
        //            let defaultvalue = {
        //                value: "NON",
        //                label: "--Select--"
        //            }
        //            locCategory.push(defaultvalue)
        //        }
        //        let localArray = {
        //            value: val.CATEGORY_ID,
        //            label: val.CAT_DESCR
        //        }

        //        locCategory.push(localArray)
        //    });
        //}

        //if (Response.Category != undefined && Response.Category != null) {
        //    Response.Category.map((val, index) => {
        //        if (index == 0) {
        //            let defaultvalue = {
        //                value: "NON",
        //                label: "--Select--"
        //            }
        //            locCategory.push(defaultvalue)
        //        }
        //        let localArray = {
        //            value: val.CATEGORY_ID,
        //            label: val.CAT_DESCR
        //        }

        //        locCategory.push(localArray)
        //    });
        //}
        let locEmpId = []
        if (Response.EmpId != undefined && Response.EmpId != null) {
            Response.EmpId.map((val, index) => {
                //if (index == 0) {
                //    let defaultvalue = {
                //        value: val.ISA_EMPLOYEE_ID,
                //        label: val.EMP_NAME + "     " + val.EMAIL
                //    }
                //    locEmpId.push(defaultvalue)
                //}
                let localArray = {
                    value: val.ISA_EMPLOYEE_ID,
                    label: val.EMP_NAME + "     " + val.EMAIL
                }

                locEmpId.push(localArray)
                if (CookieService.getLocalStorageValues("Session_UserID") == val.ISA_EMPLOYEE_ID) {
                    this.setState({ SelectedEmpId: localArray })
                }
            });
        }
        //let locArea = []
        //if (Response.Area != undefined && Response.Area != null) {
        //    Response.Area.map((val, index) => {
        //        if (index == 0) {
        //            let defaultvalue = {
        //                value: "NON",
        //                label: "--Select--"
        //            }
        //            locArea.push(defaultvalue)
        //        }
        //        let localArray = {
        //            value: val.STORAGE_AREA,
        //            label: val.STORAGE_AREA
        //        }

        //        locArea.push(localArray)
        //    });
        //}
        //let locAisle = []
        //if (Response.Aisle != undefined && Response.Aisle != null) {
        //    Response.Aisle.map((val, index) => {
        //        if (index == 0) {
        //            let defaultvalue = {
        //                value: "NON",
        //                label: "--Select--"
        //            }
        //            locAisle.push(defaultvalue)
        //        }
        //        let localArray = {
        //            value: val.STOR_LEVEL_1,
        //            label: val.STOR_LEVEL_1
        //        }

        //        locAisle.push(localArray)
        //    });
        //}
        //let locShelf = []
        //if (Response.Shelf != undefined && Response.Shelf != null) {
        //    Response.Shelf.map((val, index) => {
        //        if (index == 0) {
        //            let defaultvalue = {
        //                value: "NON",
        //                label: "--Select--"
        //            }
        //            locShelf.push(defaultvalue)
        //        }
        //        let localArray = {
        //            value: val.STOR_LEVEL_3,
        //            label: val.STOR_LEVEL_3
        //        }

        //        locShelf.push(localArray)
        //    });
        //}
        //let locRow = []
        //if (Response.Row != undefined && Response.Row != null) {
        //    Response.Row.map((val, index) => {
        //        if (index == 0) {
        //            let defaultvalue = {
        //                value: "NON",
        //                label: "--Select--"
        //            }
        //            locRow.push(defaultvalue)
        //        }
        //        let localArray = {
        //            value: val.STOR_LEVEL_2,
        //            label: val.STOR_LEVEL_2
        //        }

        //        locRow.push(localArray)
        //    });
        //}
        //let locBin = []
        //if (Response.Bin != undefined && Response.Bin != null) {
        //    Response.Bin.map((val, index) => {
        //        if (index == 0) {
        //            let defaultvalue = {
        //                value: "NON",
        //                label: "--Select--"
        //            }
        //            locBin.push(defaultvalue)
        //        }
        //        let localArray = {
        //            value: val.STOR_LEVEL_4,
        //            label: val.STOR_LEVEL_4
        //        }

        //        locBin.push(localArray)
        //    });
        //}
        let locHazardCD = []
        let objhaz;
        let hazind
        if (Response.HazardCD != undefined && Response.HazardCD != null) {
            Response.HazardCD.map((val, index) => {
                if (index == 0) {
                    let defaultvalue = {
                        value: "NON",
                        label: "--Select--"
                    }
                    locHazardCD.push(defaultvalue)
                }
                let localArray = {
                    value: val.HAZ_CLASS_CD,
                    label: val.HAZ_CLASS_CD
                }

                locHazardCD.push(localArray)
            });
            hazind = locHazardCD.findIndex(id => id.value == "UNKN")
            objhaz = locHazardCD[hazind]
        }
        let locNoun = []
        let locModifier = []
        let locItemType = []
        let locStockType = []
        let objstock;
        let objItem;
        if (CookieService.getLocalStorageValues("Session_SDIEMP") == "SDI") {

            if (Response.Noun != undefined && Response.Noun != null) {
                if (Response.Noun.length > 0) {
                    Response.Noun.map((val, index) => {
                        if (index == 0) {
                            let defaultvalue = {
                                value: "NON",
                                label: "--Select--"
                            }
                            locNoun.push(defaultvalue)
                        }
                        let localArray = {
                            value: val.ID,
                            label: val.IM_NOUN
                        }

                        locNoun.push(localArray)
                    });
                }
            }

            //if (Response.Modifier != undefined && Response.Modifier != null) {
            //    if (Response.Modifier.length > 0) {
            //        Response.Modifier.map((val, index) => {
            //            if (index == 0) {
            //                let defaultvalue = {
            //                    value: "NON",
            //                    label: "--Select--"
            //                }
            //                locModifier.push(defaultvalue)
            //            }
            //            let localArray = {
            //                value: val.ID,
            //                label: val.IM_MOD15
            //            }

            //            locModifier.push(localArray)
            //        });
            //    }
            //}
            let itemtypeind
            //if (Response.ItemType != undefined && Response.ItemType != null) {
            //    if (Response.ItemType.length > 0) {
            //        Response.ItemType.map((val, index) => {
            //            //if (index == 0) {
            //            //    let defaultvalue = {
            //            //        value: "NON",
            //            //        label: "--Select--"
            //            //    }
            //            //    locItemType.push(defaultvalue)
            //            //}
            //            let localArray = {
            //                value: val.INV_ITEM_TYPE,
            //                label: val.INV_ITEM_TYPE
            //            }

            //            locItemType.push(localArray)
            //        });
            //        itemtypeind = locItemType.findIndex(id => id.value == "MRO")
            //        objItem = locItemType[itemtypeind]
            //    }
            //}
            let Stocktypeind = 0

            //if (Response.StockType != undefined && Response.StockType != null) {
            //    if (Response.StockType.length > 0) {
            //        Response.StockType.map((val, index) => {
            //            //if (index == 0) {
            //            //    let defaultvalue = {
            //            //        value: "NON",
            //            //        label: "--Select--"
            //            //    }
            //            //    locStockType.push(defaultvalue)
            //            //}
            //            let localArray = {
            //                value: val.INV_STOCK_TYPE,
            //                label: val.INV_STOCK_TYPE
            //            }

            //            locStockType.push(localArray)
            //        });
            //        Stocktypeind = locStockType.findIndex(id => id.value == "STK")
            //        objstock = locStockType[Stocktypeind]
            //    }

            //}
        }
        let locM = []
        //for (const [index, value] of locmfg.entries()) {
        //    if (index == 0) {
        //        let defaultvalue = {
        //            value: "NON",
        //            label: "--Select--"
        //        }
        //        locM.push(defaultvalue)
        //    }

        //    let localArray = {
        //        value: value[0].MFG_ID,
        //        label: value[0].DESCR
        //    }

        //    locM.push(localArray)
        //}
        let locV = [];
        for (const [index, value] of locvendor.entries()) {
            if (index == 0) {
                let defaultvalue = {
                    value: "NON",
                    label: "--Select--"
                }
                locV.push(defaultvalue)
            }
            let localArray = {
                value: value[0].VENDOR_ID,
                label: value[0].NAME1
            }

            locV.push(localArray)
        }

        this.setState({
            UMO: locUMO, UtilizationType: locUtilizationType, Category: locCategory, shipBU: locBU, EmpId: locEmpId, Noun: locNoun, ModifyArr: Response.Modifier,
            Area: locArea, BinLocation: BinLoc, ItemType: locItemType, StockType: locStockType, HazardCD: locHazardCD,
            VendorId: locV, SelectedStockType: objstock, SelectedItemType: objItem, SelectedUtilizationType: objutil, SelectedUMO: objumo,
            SelectedShipBU: objBU, SelectedHazardCD: objhaz, Manufacturer: locM, SelectedShipBU: [] //Bug  5471 BU drodown have select as default value - Nandhini L
        });
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    /**
     * CPW-94_PC_23 (9/14/2023)-Aparna
     * */
    validateMfgResponse = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        
        let Response = JSON.parse(ItemMaintenanceAStore.PageLoadData);
        let focus = false
        if (Response.MfgSuggestions != null && Response.MfgSuggestions != undefined) {
            if (Response.MfgSuggestions.length > 0) {
                let MFG = []
                focus = true
                if (Response.MfgSuggestions != undefined && Response.MfgSuggestions != null) {
                    Response.MfgSuggestions.map((val, index) => {

                        let localArray = {
                            value: val.DESCR60,
                            label: val.DESCR60,
                            name: val.MFG_ID
                        }

                        MFG.push(localArray)

                    });
                    //$("#mfgid").focus();
                    // document.getElementById("mfgid").focus()
                }
                this.setState({ MfgSuggestions: MFG, Suggestion: MFG, focus: focus });
            }
        }
    }
    /**
     * CPW-94_PC_16 (9/14/2023)-Aparna
     * */
    validateMfg = () => {
        if (this.state.SelectedManufacturer != null && this.state.SelectedManufacturer != undefined) {
            if (this.state.SelectedManufacturer.trim() != "") {

                let BO = {
                    SearchText: this.state.SelectedManufacturer
                }
                ItemMaintenanceAAction.validateMfg(BO)
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                this.setState({ focus: false })
            }
        }
    }


    /**
     * CPW-94_PC_18 (9/14/2023) -Aparna
     * */
    renderSuggestion = suggestion => (
        <div>
            {suggestion.label}
        </div>
    );

    /*
     * STK_PC_07
     * */
    SaveButtonclickResponse = () => {
        
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let Response = JSON.parse(ItemMaintenanceAStore.PageLoadData);
        let flag = Response.FlagTable;
        if (flag[0].Mfgcheck == true || flag[0].Mfgcheck == "True") {
            this.setState({ ErrMfg: true })
            return;
        }

        let ItemId = flag[0].ItemId;
        if (flag[0].Alert == true || flag[0].Alert == "True") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: flag[0].Alertmsg
            });

            //alert(flag[0].Alertmsg);

            return;

        }
        else if (flag[0].Errorflag == true || flag[0].Errorflag == "True") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: flag[0].Error
            });

            // alert(flag[0].Error);



            return;

        }
        else if (flag[0].lbldberror == true || flag[0].lbldberror == "True") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: flag[0].lbldberrormsg
            });

            // alert(flag[0].lbldberrormsg);



            return;

        }
        else {
            let SucMsg = "The request has been submitted successfully.\nRequest Id : " + ItemId;
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: SucMsg
            });
            //  alert(SucMsg);
            //BUG_2402_PC_01 (8/8/2022)-Aparna 
            this.props.history.push({
                pathname: `\HomePage`,

            });
            window.preventDefault();
            //this.setState({
            //    ItemId: "NEXT",
            //    SelectedUMO: "",
            //     SelectedUtilizationType: "",
            //     SelectedShipBU: "",
            //     SelectedCategory: "",
            //    ProductGroup: "",
            //    Description: "",
            //    Notes: "",
            //     SelectedManufacturer: "",
            //    MfgPart: "",
            //    SuggestedSupplier: "",
            //    Replenish: false,
            //    MinQtyOnHand: "",
            //    MaxQty: "",
            //     SelectedChargCD: "",
            //     SelectedEmpId: "",
            //     SelectedHazardCD: "",
            //    MSDS: "",
            //    Inceptionrequired: false,
            //    Regraind: false,
            //    FirstChargeCD: "",
            //    ETAG: "",
            //    PDS: "",
            //    DrawingCD: "",
            //    MachineCtrlNo: "",
            //    SelectedArea: "",
            //     SelectedAisle: "",
            //     SelectedRow: "",
            //     SelectedShelf: "",
            //    SelectedBin: "",
            //     SelectedNoun: "",
            //    SelectedItemType: "",
            //    SSelsectedStockType: "",
            //     SelectedModifier: "",
            //    LeadTime: "5",
            //     SelectedVendorId: "",
            //    VendorItemId: "",
            //    StdCD: "",
            //    ErrNoun: false, ErrItem: false, ErrCat: false, ErrDes: false, ErrMfgPart: false, ErrMfg: false, ErrArea: false, ErrAisel: false,
            //    ErrRow: false, ErrShelf: false, ErrModifier: false, ErrStdCost: false, ErrVendorId: false, ErrBin: false})
        }
    }
    /***
     * STK_PC_09
     * */
    CancelButtonClick = () => {
        let umoind = this.state.UMO.findIndex(id => id.value == "EA")
        let objumo = this.state.UMO[umoind]
        let itemind = this.state.UtilizationType.findIndex(id => id.value == "C")
        let objutil = this.state.UtilizationType[itemind]
        let hazind = this.state.HazardCD.findIndex(id => id.value == "UNKN")
        let objhaz = this.state.HazardCD[hazind]
        let itemtypeind = this.state.ItemType.findIndex(id => id.value == "MRO")
        let objItem = this.state.ItemType[itemtypeind]
        let Stocktypeind = this.state.StockType.findIndex(id => id.value == "STK")
        let objstock = this.state.StockType[Stocktypeind]
        //WW -328_PC_05 Add STK Items – Need to add Critical Spare Check Box (1/13/2022) -Aparna
        this.setState({
            SelectedUMO: objumo, SelectedUtilizationType: objutil, SelectedCategory: "", SelcetedshipBU: "",
            SelectedEmpId: "",
            SelectedNoun: "", ModifyArr: [],
            SelectedArea: "", SelectedAisle: "", SelectedRow: "", SelectedBin: "", SelectedShelf: "", SelectdItemType: objItem, SelectedStockType: objstock, SelectedHazardCD: objhaz,
            SelectedManufacturer: "", SelectedVendorId: "",
            SelectedShipBU: this.state.shipBU[1], ItemId: "NEXT", Description: "", Notes: "", MfgPart: "", Replenish: false, CriticalSpare: false,
            MinQtyOnHand: "", MaxQty: "", SelectedChargCD: "", FirstChargeCD: "", ETAG: "", MSDS: "", PDS: "", Inceptionrequired: false,
            DrawingCD: "", Regraind: false, MachineCtrlNo: "", StdCD: "", LeadTime: 5, VendorItemId: "", Modifier: [], SelectedModifier: "",
            ErrAisel: false, ErrArea: false, ErrCat: false, ErrDes: false, ErrItem: false, ErrMfg: false,
            ErrMfgPart: false, ErrModifier: false, ErrNoun: false, ErrRow: false, ErrShelf: false,
            ErrStdCost: false, ErrVendorId: false, ErrBin: false, ErrEmpId: false, Price: "", ErrPrice: false, ErrVendorItemID: false, AttachmentPathArrImg: [], ErrMinQH: false, ErrMaxQty: false
        })
        //console.log("this.state.shipBU[1]", this.state.shipBU[1])
    }
    /***
     * STK_PC_06
     * */
    selectAreaChange = (e) => {
        
        let area = e;
        let Aisledd = [];
        let locErrArea = false
        this.state.BinLocation.map((item, index) => {
            if (item.STORAGE_AREA == e.value && Aisledd.indexOf(item.STOR_LEVEL_1) == -1) {
                let obj = {
                    value: item.STOR_LEVEL_1,
                    label: item.STOR_LEVEL_1
                }
                Aisledd.push(obj);
            }
        })

        if (area == "" || area == null || area == undefined) {

            locErrArea = true

        }
        else {

            locErrArea = false

        }

        let pp = Aisledd.filter((ele, ind) => ind === Aisledd.findIndex(elem => elem.value === ele.value && elem.label === ele.label))
        //9/6/22, Bug - 2577, To make the dependency dropdowns empty based on the selected value changes, Dhevanesam R] 
        //9/14/22, Bug - 2577, To make other dropdowns empty when the selected value changes, Dhevanesam R] 
        if (this.state.SelectedArea != null && this.state.SelectedArea != " " && this.state.SelectedArea != "" && this.state.SelectedArea != undefined) {
            if (this.state.SelectedArea.value == area.value) {
                this.setState({ Aisle: pp, SelectedArea: area })
            }
            else {
                this.setState({ Aisle: pp, Row: [], Shelf: [], Bin: [], SelectedArea: area, ErrArea: locErrArea, SelectedAisle: "", SelectedRow: "", SelectedShelf: "", SelectedBin: "" })
            }
        }
        else {
            this.setState({ Aisle: pp, Row: [], Shelf: [], Bin: [], SelectedArea: area, SelectedAisle: "", ErrArea: locErrArea, SelectedRow: "", SelectedShelf: "", SelectedBin: "" })
        }

    }


    selectAisleChange = (e) => {
        
        let aisle = e;
        let Rowdd = [];
        let locErrAisle = false;
        this.state.BinLocation.map((item, index) => {
            if (item.STORAGE_AREA == this.state.SelectedArea.value && item.STOR_LEVEL_1 == e.value
                && Rowdd.indexOf(item.STOR_LEVEL_2) == -1
            ) {
                let obj = {
                    value: item.STOR_LEVEL_2,
                    label: item.STOR_LEVEL_2
                }
                Rowdd.push(obj);
            }
        })

        if (aisle == "" || aisle == null || aisle == undefined) {

            locErrAisle = true

        }
        else {

            locErrAisle = false

        }
        let pp = Rowdd.filter((ele, ind) => ind === Rowdd.findIndex(elem => elem.value === ele.value && elem.label === ele.label))
        //this.setState({ Row: pp, SelectedAisle: aisle, SelectedRow: "", SelectedShelf: "", SelectedBin: "" })
        //9/6/22, Bug - 2577, To make the dependency dropdowns empty based on the selected value changes, Dhevanesam R] 
        //9/14/22, Bug - 2577, To make other dropdowns empty when the selected value changes, Dhevanesam R] 
        if (this.state.SelectedAisle != null && this.state.SelectedAisle != " " && this.state.SelectedAisle != "" && this.state.SelectedAisle != undefined) {
            if (this.state.SelectedAisle.value == aisle.value) {
                this.setState({ Row: pp, SelectedAisle: aisle })
            }
            else {
                this.setState({ Row: pp, Shelf: [], Bin: [], SelectedAisle: aisle, ErrAisel: locErrAisle, SelectedRow: "", SelectedShelf: "", SelectedBin: "" })
            }
        }
        else {
            this.setState({ Row: pp, Shelf: [], Bin: [], SelectedAisle: aisle, SelectedRow: "", ErrAisel: locErrAisle, SelectedShelf: "", SelectedBin: "" })
        }
    }

    selectRowChange = (e) => {
        
        let row = e;
        let Shelfdd = [];
        let locErrRow = false;
        this.state.BinLocation.map((item, index) => {
            if (item.STORAGE_AREA == this.state.SelectedArea.value && item.STOR_LEVEL_1 == this.state.SelectedAisle.value
                && item.STOR_LEVEL_2 == e.value && Shelfdd.indexOf(item.STOR_LEVEL_3) == -1
            ) {
                let obj = {
                    value: item.STOR_LEVEL_3,
                    label: item.STOR_LEVEL_3
                }
                Shelfdd.push(obj);
            }
        })

        if (row == "" || row == null || row == undefined) {

            locErrRow = true

        }
        else {

            locErrRow = false

        }
        let pp = Shelfdd.filter((ele, ind) => ind === Shelfdd.findIndex(elem => elem.value === ele.value && elem.label === ele.label))
        //this.setState({ Shelf: pp, SelectedRow: row, SelectedShelf: "", SelectedBin: "" })
        //9/6/22, Bug - 2577, To make the dependency dropdowns empty based on the selected value changes, Dhevanesam R] 
        //9/14/22, Bug - 2577, To make other dropdowns empty when the selected value changes, Dhevanesam R] 
        if (this.state.SelectedRow != null && this.state.SelectedRow != " " && this.state.SelectedRow != "" && this.state.SelectedRow != undefined) {
            if (this.state.SelectedRow.value == row.value) {
                this.setState({ Shelf: pp, SelectedRow: row })
            }
            else {
                this.setState({ Shelf: pp, Bin: [], SelectedRow: row, ErrRow: locErrRow, SelectedShelf: "", SelectedBin: "" })
            }
        }
        else {
            this.setState({ Shelf: pp, Bin: [], SelectedRow: row, SelectedShelf: "", ErrRow: locErrRow, SelectedBin: "" })
        }
    }

    selectShelfChange = (e) => {
        
        let shelf = e;
        let Bindd = [];
        let locErrShelf = false;
        this.state.BinLocation.map((item, index) => {
            if (item.STORAGE_AREA == this.state.SelectedArea.value && item.STOR_LEVEL_1 == this.state.SelectedAisle.value
                && item.STOR_LEVEL_3 == e.value && item.STOR_LEVEL_2 == this.state.SelectedRow.value && Bindd.indexOf(item.STOR_LEVEL_4) == -1
            ) {
                let obj = {
                    value: item.STOR_LEVEL_4,
                    label: item.STOR_LEVEL_4
                }
                Bindd.push(obj);
            }
        })

        if (shelf == "" || shelf == null || shelf == undefined) {

            locErrShelf = true

        }
        else {

            locErrShelf = false

        }
        let pp = Bindd.filter((ele, ind) => ind === Bindd.findIndex(elem => elem.value === ele.value && elem.label === ele.label))
        //this.setState({ Bin: pp, SelectedShelf: shelf, SelectedBin: "" })
        //9/6/22, Bug - 2577, To make the dependency dropdowns empty based on the selected value changes, Dhevanesam R] 
        if (this.state.SelectedShelf != null && this.state.SelectedShelf != " " && this.state.SelectedShelf != "" && this.state.SelectedShelf != undefined) {
            if (this.state.SelectedShelf.value == shelf.value) {
                this.setState({ Bin: pp, SelectedShelf: shelf })
            }
            else {
                this.setState({ Bin: pp, SelectedShelf: shelf, SelectedBin: "", ErrShelf: locErrShelf })
            }
        }
        else {
            this.setState({ Bin: pp, SelectedShelf: shelf, SelectedBin: "", ErrShelf: locErrShelf })
        }
    }
    selectBinChange = (e) => {
        
        let bin = e;
        let locErrBin = false;

        if (bin == "" || bin == null || bin == undefined) {

            locErrBin = true

        }
        else {

            locErrBin = false

        }

        this.setState({ SelectedBin: bin, ErrBin: locErrBin })
    }
    onChangeInputDescription = (e, name) => {
        let locErrDesc = false;
        if (name == "Description") {
            if (e.target.value == "" || e.target.value == null || e.target.value == undefined) {

                locErrDesc = true

            }
            else {

                locErrDesc = false

            }
            this.setState({
                ErrDes: locErrDesc, [e.target.name]: e.target.value
            })
        }
    }
    onChangeInputMFGPart = (e, name) => {
        let locErrMfgPart = false
        if (name == "MfgPart") {
            if (e.target.value == "" || e.target.value == null || e.target.value == undefined) {

                locErrMfgPart = true

            }
            else {

                locErrMfgPart = false

            } this.setState({
                ErrMfgPart: locErrMfgPart, [e.target.name]: e.target.value
            })


        }
    }

    onChangeInputEmpId = (e, name) => {
        if (name == "SelectedEmpId") {
            let locErrEmpId = false
            if (e == "" || e == null || e == undefined) {

                locErrEmpId = true

            }
            else {

                locErrEmpId = false

            }
            this.setState({
                ErrEmpId: locErrEmpId, [name]: e
            })
        }
    }

    onChangeInputManugacturer = (e, name) => {
        let locErrMfg = false;
        if (e.target.value == "" || e.target.value == null || e.target.value == undefined) {

            locErrMfg = true

        }
        else {

            locErrMfg = false

        }
        this.setState({
            ErrMfg: locErrMfg, [name]: e.target.value
        })
    }

    onChangeInputVendorId = (e, name) => {


        if (name == "SelectedVendorId") {
            let locErrVendorId = false
            if (e == "" || e == null || e == undefined) {

                locErrVendorId = true

            }
            else {

                locErrVendorId = false

            }
            this.setState({ ErrVendorId: locErrVendorId, [name]: e });
        }
    }

    onChangeInput = (e, name) => {

        let locErrDesc = false;
        let locErrMfgPart = false;
        let locErrMfg = false;
        let locErrEmpId = false;
        let locErrVendorId = false;
        let locErrVendorItemId = false;
        let locErrPrice = false;
        let locErrMinQty = false;
        let locErrMaxQty = false;
        
        switch (name) {
            case "SelectedUMO": case "SelectedShipBU": case "SelectedCategory": case "SelectedChargCD": case "SelectedEmpId":
            case "SelectedHazardCD": case "SelectedArea": case "SelectedAisle": case "SelectedRow": case "SelectedShelf": case "SelectedItemType":
            case "SelectedStockType": case "SelectedModifier": case "SelectedBin": case "SelectedVendorId": case "SelectedNoun": case "SelectedUtilizationType":
                {
                    if (name == "SelectedEmpId") {
                        if (e == "" || e == null || e == undefined) {

                            locErrEmpId = true

                        }
                        else {

                            locErrEmpId = false
                            this.setState({ [name]: e });
                        }
                    }
                    if (name == "SelectedVendorId") {
                        if (e == "" || e == null || e == undefined) {

                            locErrVendorId = true

                        }
                        else {

                            locErrVendorId = false
                            this.setState({ [name]: e });
                        }
                    }

                    if (name == "SelectedNoun") {
                        const locMo = this.state.ModifyArr.reduce(
                            (result, item) =>
                                result.set(
                                    item.IM_NOUN,
                                    (result.get(item.IM_NOUN) || []).concat(item)
                                ),
                            new Map()
                        );
                        let locM = []
                        for (const [index, value] of locMo.entries()) {

                            if (index == e.label) {
                                locMo.get(index).map((val, index) => {
                                    if (index == 0) {
                                        let defaultvalue = {
                                            value: "0",
                                            label: "--Select Asset ID--"
                                        }
                                        locM.push(defaultvalue)
                                    }
                                    let localArray = {
                                        value: val.ID,
                                        label: val.IM_MOD15
                                    }

                                    locM.push(localArray)
                                });
                            }


                        }
                        //for (const [index, value] of locMo.entries()) {
                        //    if (index == 0) {
                        //        let defaultvalue = {
                        //            value: "NON",
                        //            label: "--Select--"
                        //        }
                        //        locM.push(defaultvalue)
                        //    }
                        //    let localArray = {
                        //        value: value[0].ID,
                        //        label: value[0].IM_MOD15
                        //    }

                        //    locM.push(localArray)
                        //}
                        this.setState({ Modifier: locM, SelectedModifier: "", [name]: e })
                    }
                    else {
                        this.setState({ [name]: e });
                    }

                    break;
                }
            case "ItemId": case "ProductGroup": case "Description": case "Notes": case "MfgPart": case "SuggestedSupplier":
            case "ChargeCD": case "MSDS": case "FirstChargeCD": case "ETAG":
            case "PDS": case "DrawingCD": case "MachineCtrlNo": case "LeadTime": case "StdCD": case "VendorItemId":
                {
                    if (name == "Description") {
                        if (e.target.value == "" || e.target.value == null || e.target.value == undefined) {

                            locErrDesc = true

                        }
                        else {

                            locErrDesc = false
                            this.setState({ [e.target.name]: e.target.value });
                        }
                    }
                    if (name == "MfgPart") {
                        if (e.target.value == "" || e.target.value == null || e.target.value == undefined) {

                            locErrMfgPart = true

                        }
                        else {

                            locErrMfgPart = false
                            this.setState({ [e.target.name]: e.target.value });
                        }
                    }
                    if (name == "VendorItemId") {
                        if (e.target.value == "" || e.target.value == null || e.target.value == undefined) {

                            locErrVendorItemId = true

                        }
                        else {

                            locErrVendorItemId = false
                            this.setState({ [e.target.name]: e.target.value });
                        }
                    }

                    //console.log("UMO", e)
                    this.setState({ [e.target.name]: e.target.value });
                    break;
                }
            case "MinQtyOnHand": case "MaxQty": {
                const reg = /^\d+$/


                if (parseInt(e.target.value) >= 0) {
                    if (reg.test(e.target.value)) {
                        this.setState({ [e.target.name]: e.target.value });
                    }
                    //else {
                     //   if (e.target.name == "MinQtyOnHand") {
                      //      locErrMinQty = true
                      //  } else {
                     //       locErrMaxQty = true
                     //   }
                    //}

                }

                // Regression Bug - 5475 - K. Surya  - In Add stock item panel we display validation on clearing the entered value.

                else if (e.target.value == "") {
                    if (e.target.name == "MinQtyOnHand") {
                        locErrMinQty = true
                    } else if (e.target.name == "MaxQty") {
                        locErrMaxQty = true
                    }
                    this.setState({ [e.target.name]: e.target.value });
                }
                //BUG: 2317- Incase of negative qty, next statements were executed-Priyanka D
                break;
            }
            //CPW-94_PC_14 -Aparna
            case "Price": {
                const re = SDIConstants.PriceRegex
                if (e.target.value != null && e.target.value != undefined) {
                    if (re.test(e.target.value)) {
                        this.setState({ [e.target.name]: e.target.value });
                    }
                }
                else {
                    locErrPrice = true
                }
                break;
            }

            case "Replenish": {
                this.setState({ Replenish: this.state.Replenish == false ? true : false });
                break;
            }// WW-328_PC_02 Add STK Items – Need to add Critical Spare Check Box (1/13/2022) -Aparna
            case "CriticalSpare": {
                this.setState({ CriticalSpare: this.state.CriticalSpare == false ? true : false });
                break;
            }
            case "Inceptionrequired": {
                this.setState({ Inceptionrequired: this.state.Inceptionrequired == false ? true : false });
                break;
            }
            case "Regraind": {
                this.setState({ Regraind: this.state.Regraind == false ? true : false });
                break;
            }
            case "SelectedManufacturer": {
                this.setState({ SelectedManufacturer: e })
                //if (e.target.value == "" || e.target.value == null || e.target.value == undefined) {

                //    locErrMfg = true

                //}
                //else {

                //    locErrMfg = false
                //    this.setState({ [name]: e.target.value });
                //}

            }


        }


        this.setState({
            ErrDes: locErrDesc, ErrMfgPart: locErrMfgPart, ErrMfg: locErrMfg, ErrEmpId: locErrEmpId, ErrVendorId: locErrVendorId,
            ErrVendorItemID: locErrVendorItemId, ErrPrice: locErrPrice, ErrMinQH: locErrMinQty, ErrMaxQty: locErrMaxQty
        })
    }
    /***
    *STK_PS_07
    */
    SaveButtonClick = (e) => {

        let inputempty = false
        let locErrDesc = false
        let locErrItem = false
        let locErrCat = false
        let locErrDes = false
        let locErrMfg = false
        let locErrMfgPart = false
        let locErrArea = false
        let locErrAisle = false
        let locErrShelf = false
        let locErrRow = false
        let locErrEmpId = false
        let locErrBin = false
        let locErrNoun = false
        let locErrModifier = false
        let locErrStdCost = false
        let locErrVendorId = false
        let locErrPrice = false
        let locErrVendorItemID = false
        let locErrMinQH = false
        let locMaxQty = false
        // if (CookieService.getLocalStorageValues("Session_SDIEMP") == "SDI") {
        //if (this.state.SelectedNoun.value == "NON" || this.state.SelectedNoun == "") {
        //    inputempty = true
        //    locErrNoun = true
        //}
        //if (this.state.SelectedModifier.value == "NON" || this.state.SelectedModifier == "") {
        //    inputempty = true
        //    locErrModifier = true
        //}
        //if (this.state.StdCD == "" || this.state.StdCD == null || this.state.StdCD == undefined) {
        //    inputempty = true
        //    locErrStdCost = true
        //} {/*WW-241 (11/24/2021)***/}

        //  }[07/12/2022 , BUG 2316 VALIDATION error ]Pavithra R

        let MinNumber = parseInt(this.state.MinQtyOnHand)
        let MaxNumber = parseInt(this.state.MaxQty)
        if (MinNumber > MaxNumber) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Min Quantity is greater than Max Quantity'
            });
            return;
        }

        if (this.state.SelectedVendorId.value == "NON" || this.state.SelectedVendorId == "") {
            inputempty = true
            locErrVendorId = true
        }
        if (this.state.ItemId == "" || this.state.ItemId == null || this.state.ItemId == undefined) {
            inputempty = true
            locErrItem = true
        }
        if (this.state.Description != null && this.state.Description != undefined) {
            if (this.state.Description.trim() == "") {
                inputempty = true
                locErrDesc = true
            }
        } else {
            inputempty = true
            locErrDesc = true
        }
        if (this.state.MfgPart != null && this.state.MfgPart != undefined) {
            if (this.state.MfgPart.trim() == "") {
                inputempty = true
                locErrMfgPart = true
            }
        } else {
            inputempty = true
            locErrMfgPart = true
        }
        //if (this.state.SelectedCategory == "NON" || this.state.SelectedCategory=="") {
        //    inputempty = true
        //    locErrCat=true
        //} **WW-241 

        if (this.state.SelectedManufacturer == "NON" || this.state.SelectedManufacturer.trim() == "") {
            inputempty = true
            locErrMfg = true
        }
        if (this.state.SelectedArea == "NON" || this.state.SelectedArea == "") {
            inputempty = true
            locErrArea = true
        }
        if (this.state.SelectedAisle == "NON" || this.state.SelectedAisle == "") {
            inputempty = true
            locErrAisle = true
        }
        if (this.state.SelectedBin == "NON" || this.state.SelectedBin == "") {
            inputempty = true
            locErrBin = true
        }
        if (this.state.SelectedShelf == "NON" || this.state.SelectedShelf == "") {
            inputempty = true
            locErrShelf = true
        }
        if (this.state.SelectedRow == "NON" || this.state.SelectedRow == "") {
            inputempty = true
            locErrRow = true
        }
        if (this.state.SelectedEmpId == " " || this.state.SelectedEmpId == "") {
            inputempty = true
            locErrEmpId = true
        }
        if (this.state.Price != null && this.state.Price != undefined) {
            if (this.state.Price.trim() == "") {
                inputempty = true
                locErrPrice = true
            }

        } else {
            inputempty = true
            locErrPrice = true
        }

        if (this.state.VendorItemId != null && this.state.VendorItemId != undefined) {
            if (this.state.VendorItemId.trim() == "") {
                inputempty = true
                locErrVendorItemID = true
            }
        }
        else {
            inputempty = true
            locErrVendorItemID = true
        }
        if (this.state.MinQtyOnHand != null && this.state.MinQtyOnHand != undefined) {
            if (this.state.MinQtyOnHand.trim() == "") {
                inputempty = true
                locErrMinQH = true
            }
        }
        else {
            inputempty = true
            locErrMinQH = true
        }
        if (this.state.MaxQty != null && this.state.MaxQty != undefined) {
            if (this.state.MaxQty.trim() == "") {
                inputempty = true
                locMaxQty = true
            }
        } else {
            inputempty = true
            locMaxQty = true
        }
        if (inputempty == false) {
            let imgfilepath = ""
            if (this.state.AttachmentPathArrImg != []) {
                if (this.state.AttachmentPathArrImg.length > 0) {
                    if (this.state.AttachmentPathArrImg[0].FilePath != null && this.state.AttachmentPathArrImg != undefined) {
                        imgfilepath = this.state.AttachmentPathArrImg[0].FilePath
                    }
                }
            }
            let imgfilename = ""
            if (this.state.AttachmentPathArrImg != []) {
                if (this.state.AttachmentPathArrImg.length > 0) {
                    if (this.state.AttachmentPathArrImg[0].FileName != null && this.state.AttachmentPathArrImg[0].FileName != undefined) {
                        imgfilename = this.state.AttachmentPathArrImg[0].FileName
                    }
                }
            }
            let BO = {
                Session_UserID: CookieService.getLocalStorageValues("Session_UserID"),
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                Session_CONAME: CookieService.getLocalStorageValues("Session_CONAME"),
                Session_COMPANYID: CookieService.getLocalStorageValues("Session_COMPANYID"),
                Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
                Session_CUSTID: CookieService.getLocalStorageValues("Session_CUSTID"),
                Session_ItemMode: CookieService.getLocalStorageValues("Session_ITEMMODE"),
                Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
                Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
                Session_SmallSite: CookieService.getLocalStorageValues("Session_SmallSite"),
                Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
                ACT: "ADD",
                strUOM: this.state.SelectedUMO.value,
                //strCATEGORY: " ",// this.state.SelectedCategory.value,
                strDESCRIPTION: this.state.Description,
                strNOTES: (this.state.Notes != null && this.state.Notes != undefined ? this.state.Notes.trim() == "" ? "-" : this.state.Notes : "-"),
                strMFGID: this.state.MFG_ID != null && this.state.undefined ? this.state.MFG_ID : this.state.SelectedManufacturer,
                strMFGITMID: this.state.MfgPart,
                strMFGPARTNO: this.state.MfgPart,
                strREPLEN: this.state.Replenish,
                strMINQOH: (this.state.MinQtyOnHand == "" || this.state.MinQtyOnHand == " " ? "-" : this.state.MinQtyOnHand),
                strMAXQOH: (this.state.MaxQty == "" || this.state.MaxQty == " " ? "-" : this.state.MaxQty),
                //strCHRCODE: this.state.SelectedChargCD.value,
                strEmpId: "AUTOSYS",//this.state.SelectedEmpId.value,
                strEMPName: this.state.SelectedEmpId.label,
                // strFirstChgCD: this.state.FirstChargeCD,
                //strMachine: this.state.MachineCtrlNo,
                // strUtilzType: "B",//this.state.SelectedUtilizationType.value,
                SDIONLY: CookieService.getLocalStorageValues("Session_SDIEMP") == "SDI" ? true : false,
                // strItemType: " ",// this.state.SelectedItemType.value,
                // strStockType: "STK",
                // strCost: " ",// this.state.StdCD,
                strArea: this.state.SelectedArea.value,
                strAisle: this.state.SelectedAisle.value,
                strRow: this.state.SelectedRow.value,
                strBin: this.state.SelectedBin.value,
                strShelf: this.state.SelectedShelf.value,
                //  strHAZCODE: "UNKN",//this.state.SelectedHazardCD.value,
                //strETAG: this.state.ETAG,
                //strINSPECT: this.state.Inceptionrequired,
                //strPDS: this.state.PDS,
                // strREGRIND: this.state.Regraind,
                //strDRAWCD: this.state.DrawingCD,
                // strProductGroup: this.state.ProductGroup,
                strVendorID: this.state.SelectedVendorId.value,
                strVendorName: this.state.SelectedVendorId.label,
                strVendorItemID: (this.state.VendorItemId == "" || this.state.VendorItemId == " " ? "-" : this.state.VendorItemId),
                // strNoun: " ",//this.state.SelectedNoun.value,
                // strModifier: " ",// this.state.SelectedModifier.value,
                //  strUtilzType: "B", //this.state.SelectedUtilizationType.value,
                strItemid: this.state.ItemId,
                strBU: this.state.SelectedShipBU.value,
                siteprefixBoolean: false,
                strCriticalSpare: this.state.CriticalSpare, // WW-328_PC_03 Add STK Items – Need to add Critical Spare Check Box (1/13/2022) -Aparna
                Price: this.state.Price,
                Employee_ID: CookieService.getLocalStorageValues("Session_UserID"),
                Employee_Name: CookieService.getLocalStorageValues("Session_USERNAME"),
                Employee_Email: CookieService.getLocalStorageValues("Session_EMAIL"),
                BU: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                ImageBytes: imgfilepath,
                ImageName: imgfilename,
                Supplier_Name: this.state.SelectedVendorId.label,
                Supplier_PartNo: this.state.SelectedVendorId.value,
                Manufacturer: this.state.MFG_ID != null && this.state.undefined ? this.state.MFG_ID : this.state.SelectedManufacturer,
                MFG_VNDR_ITM_ID: this.state.MfgPart,
                IsWeb: true,
                // Existing_Img_Url: this.state.ItemImage[this.state.currentImageIndex].original
            }
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            ItemMaintenanceAAction.SaveButtonClickAction(BO)

        }
        else {
            this.setState({
                ErrAisel: locErrAisle, ErrArea: locErrArea, ErrCat: locErrCat, ErrDes: locErrDesc, ErrItem: locErrItem, ErrMfg: locErrMfg,
                ErrMfgPart: locErrMfgPart, ErrModifier: locErrModifier, ErrNoun: locErrModifier, ErrRow: locErrRow, ErrShelf: locErrShelf,
                ErrStdCost: locErrStdCost, ErrVendorId: locErrVendorId, ErrBin: locErrBin, ErrEmpId: locErrEmpId, ErrPrice: locErrPrice, ErrVendorItemID: locErrVendorItemID,
                ErrMinQH: locErrMinQH, ErrMaxQty: locMaxQty
            });
        }
    }
    /**
     * CPW-94_PC_07
     * Aparna
     * */
    onInputClick = (event) => {
        event.target.value = ''
    }
    /**
     * CPW-94_PC_07
     * Aparna
     * */
    handleAttachment = (event) => {
        if (event.target.files != null && event.target.files != undefined && event.target.files != "") {
            if (event.target.files.length > 0) {

                if (event.target.files.length == 1) {
                    let files = event.target.files;
                    $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                    ItemDetailNewAction.addAttachment(files);
                }
                else {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Please select only one image for upload."
                    });
                }
            }

        }
    }
    /**
     * CPW-94_PC_11
     * to bind the attachment
     * Aparna
     * */
    bindAttachments = () => {
        if (this.state.AttachmentPathArrImg) {
            return this.state.AttachmentPathArrImg.map((attachment, index) => {
                return (
                    <span className="attachment-file-name pl-0 my-2 pr-3 d-inline-block" key={index}>
                        <a href="#" className="noncat-Attachment-overflow" data-toggle="tooltip" title={attachment.FileName} onClick={(e) => this.downloadAttachment(e, attachment)}>{attachment.FileName}</a>
                        <span className="attachment-remove-icon ml-1" onClick={() => this.removeAttachment(attachment.FilePath, index)}>X</span>
                    </span>
                );
            });
        }
    };
    /**
     * CPW-94_PC_12
     * to download the attachment
     * Aparna
     * */
    downloadAttachment = (e, attachment) => {
        e.preventDefault();
        let downloadBO = {
            fileName: attachment.FileName,
            filePath: attachment.FilePath
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        NonCatalogAction.downloadAttachment(downloadBO);
    };
    /**
     * CPW-94_PC_13
     * to remove attachment 
     * Aparna
     * */
    removeAttachment = (filepath, index) => {
        rmvAttachindex = index
        let removeBO = {
            filePath: filepath
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        NonCatalogAction.removeAttachment(removeBO);
    }
    /**
     * CPW-94_PC_14
     * Response of the remove attachment
     * */
    removeAttachmentResponse = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let isValid = NonCatalogStore.removeAttachmentResponse.indexOf("success") >= 0 ? true : false;
        if (isValid) {
            let tempAttachments = this.state.AttachmentPathArrImg;
            tempAttachments.splice(rmvAttachindex, 1);
            this.setState({ AttachmentPathArrImg: tempAttachments });
            rmvAttachindex = -1;
        }
    };
    /**
     * CPW-94_PC_09
     * response 
     * Aparna
     * */
    addAttachementResponse = () => {
        
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let isValid = ItemDetailNewStore.attachmentResponse.indexOf("You have exceeded the length of total file names") >= 0 ? false : true;
        if (isValid) {
            let attachmentResponse = JSON.parse(ItemDetailNewStore.attachmentResponse);
            //let tempAttachments = this.state.attachmentPathArrImg;
            //tempAttachments = tempAttachments.concat(attachmentResponse);
            if (!(attachmentResponse[0].FileName.toLowerCase().includes('jpg') || (attachmentResponse[0].FileName.toLowerCase().includes('png')) || (attachmentResponse[0].FileName.toLowerCase().includes('jpeg')))) {
                // alert("You can choose only the Image files!!")
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: 'You can choose only the Image files!!'
                });
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                $('#alertpopup').modal('hide');
                return;
            }
            this.setState({ AttachmentPathArrImg: attachmentResponse });
        } else {

            alert("You have exceeded the length of total file names. \nPlease adjust your entry or remove longer file names.")
            $('#alertpopup').modal('hide');
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            return;

        }
    }
    /**
     * CPW-94_PC_20 (9/14/2023) -Aparna
     * */
    //OnChangeMfg = (event, { newValue }) => {

    //    this.setState({
    //        SelectedManufacturer: newValue
    //});
    //};
    OnChangeMfg = (e) => {
        let result = []
        let val = e.target.value
        if (e.target.value == "") {

            this.setState({
                SelectedManufacturer: e.target.value, Suggestion: this.state.MfgSuggestions
            });
        }
        if (this.state.MfgSuggestions != undefined && this.state.MfgSuggestions != null) {
            if (this.state.MfgSuggestions.length != 0) {
                result = this.state.MfgSuggestions.filter(name => name.label.toUpperCase().includes(val))
                //console.log("yourcat autocomplete", result)
            }
        }

        this.setState({
            SelectedManufacturer: e.target.value, Suggestion: result
        });
    };
    onSelect = (val) => {
        let result = []
        let mfg=""
        if (this.state.Suggestion.length > 0) {
            result = this.state.Suggestion.filter(name => name.label.toUpperCase() == val.toUpperCase())
        }
        if (result != null && result != undefined && result == []) {
            mfg = result[0].name
        }
        else {
            mfg = ""
        }
        this.setState({
            SelectedManufacturer: val, focus: false, ErrMfg: false, MFG_ID: mfg
        });


    }
    clearSearch = () => {
        this.setState({ SelectedManufacturer: "", Suggestion: [] });
    }
    /***
 * CPW-94_PC_22 (9/14/2023)-Aparna
 * */
    //getSuggestions = value => {

    //};
    /**
     * CPW-94_PC_21 (9/14/2023)-Aparna
     * */
    onSuggestionsFetchRequested = ({ value }) => {
        let inputValue = value.trim().toLowerCase();
        let inputLength = inputValue.length;
        let sug = []
        sug = this.state.MfgSuggestions.length > 0 ? inputLength === 0 ? [] : this.state.SelectedManufacturer.filter(x =>
            x.MFG_ID.toLowerCase().slice(0, inputLength) === inputValue
        ) : [];
        this.setState({
            MfgSuggestions: sug
        });
    };

    /***
     * CPW-94_PC_21 (9/14/2023)-Aparna
     * */
    onSuggestionsClearRequested = () => {
        this.setState({
            MfgSuggestions: []
        });
    };
    /**
     * 
     * */
    getSuggestionValue = suggestion => suggestion.MFG_ID;
    renderItem(item, isHighlighted) {
        return (
            <div key={item.label} style={{ background: isHighlighted ? 'lightgray' : 'white' }}>
                {item.label}
            </div>
        );

    }
    getItemValue(item) {
        // You can obviously only return the Label or the component you need to show
        // In this case we are going to show the value and the label that shows in the input
        // something like "1 - Microsoft"
        return `${item.value}`;
    }
    AnykeyPress(e) {
        if (e.keyCode == 13) {
            this.validateMfg()
        }
    };
    onfocusloose = () => {
        this.setState({ focus: false })
    }
    onclickmfg = () => {
        this.setState({ focus: true })
    }
    render() {

        const inputProps = {
            placeholder: 'Enter Manufacturer',
            value: this.state.SelectedManufacturer,
            onChange: this.OnChangeMfg
        };
        return (
            <React.Fragment>
                <div className="container-fluid content-margin Top-margin custom-mb">
                    <div className="row mx-0 d-flex ">{/***justify-content-center*/}
                        <div className="col-lg-12 float-left px-0">
                            <div className="col-md-12 page-heading mb-3 float-left p-0">
                                <h5 className="page-title pl-3 mr-0"><Trans>Add Stock Items</Trans></h5>{/*WW-333_PC_02 Add Stock Item Panel has Truck Stock Locations and Needs to be Re-labeled Add Stock Items vs. "Item Maintenance"(1/12/2022) -Aparna**/}
                                <div className="fav-item-maintenance-icon mt-1">
                                    <input type="checkbox" id="checkbox-OrdStatus" className="checknow" name="isFavorited" checked={this.state.isFavorited} onChange={this.handleFavorite} />
                                    <label htmlFor="checkbox-OrdStatus">
                                        <svg className="heart-svg" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">
                                            <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                                <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                                <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                                <g className="grp7" opacity={0} transform="translate(7 6)">
                                                    <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                                    <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                                </g>
                                                <g className="grp6" opacity={0} transform="translate(0 28)">
                                                    <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                                    <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                                </g>
                                                <g className="grp3" opacity={0} transform="translate(52 28)">
                                                    <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                                    <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                                </g>
                                                <g className="grp2" opacity={0} transform="translate(44 6)">
                                                    <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                                    <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                                </g>
                                                <g className="grp5" opacity={0} transform="translate(14 50)">
                                                    <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                                    <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                                </g>
                                                <g className="grp4" opacity={0} transform="translate(35 50)">
                                                    <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                                    <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                                </g>
                                                <g className="grp1" opacity={0} transform="translate(24)">
                                                    <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                                    <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                                </g>
                                            </g>
                                        </svg>
                                    </label>
                                </div>
                            </div>
                        </div>
                        {/*<div class="col-lg-11  float-left px-0 mt-3">
                    <div class="row mx-0">
                        <div class="col-md-6 col-lg-3 float-left mb-3">
                            <label class="catalog-label " for="item-id">Item ID</label>
                            <input type="text" class="form-control" id="item-id" name="example1">
                        </div>    
                    </div>                
                </div>*/}
                        <div className="col-lg-12 border-bottom  px-0 mt-3">
                            <div className="row mb-2  mx-0">
                                {/*
                                <div className="col-md-6 col-lg-2 float-left mb-3">
                                    <label className="catalog-label " htmlFor="stkitem-id"><Trans>Item ID</Trans></label>
                                    <input type="text" maxLength={20}  className="form-control" id="stkitem-id" name="ItemId" value={this.state.ItemId} onChange={e => this.onChangeInput(e, "ItemId")} />
                                    {this.state.ErrItem ? <span className="errorspan1" style={{ fontSize: '10px' }}><Trans>Enter</Trans><span> </span><Trans>Item ID</Trans></span> : null}
                                </div>
                                */}
                                <div className="col-md-6 col-lg-2  mb-3">
                                    <label className="w-100 catalog-label "><Trans>unitofmeasure_key</Trans></label>{/*UMO is not an mandetary field* **[class "mandatory" removed]*/}
                                    <Select
                                        className="DropDown-Font-Size"
                                        options={this.state.UMO}
                                        value={this.state.SelectedUMO}
                                        onChange={e => this.onChangeInput(e, "SelectedUMO")}
                                        name="UMO"
                                    />
                                </div>
                                {/*<div className="col-md-6 col-lg-2  mb-3">
                                    <label className="w-100 catalog-label"><Trans>Utilization type</Trans></label>
                                    <Select
                                        className="DropDown-Font-Size"
                                        options={this.state.UtilizationType}
                                        value={this.state.SelectedUtilizationType}
                                        onChange={e => this.onChangeInput(e, "SelectedUtilizationType")}
                                        name="UtilizationType"
                                        isSearchable={false}
                                    />
                                </div>{/**WW-241 searchable removed (11/24/2021)*/}
                                <div className="col-md-6 col-lg-2 mb-3">
                                    <label className="w-100 catalog-label"><Trans>Business Unit</Trans></label>
                                    <Select
                                        className="DropDown-Font-Size"
                                        options={this.state.shipBU}
                                        value={this.state.SelectedShipBU}
                                        onChange={e => this.onChangeInput(e, "SelectedShipBU")}
                                        name="shipBU"
                                    />
                                </div>
                                {/*<div className="col-md-6 col-lg-2 mb-3 ">
                                    <label className="w-100 catalog-label mandatory"><Trans>Category</Trans></label>
                                    <Select
                                        className="DropDown-Font-Size"
                                        options={this.state.Category}
                                        value={this.state.SelectedCategory}
                                        onChange={e => this.onChangeInput(e,"SelectedCategory")}
                                        name="Category"
                                    />
                                </div>*/}{/*WW-241 (11/24/2021)***/}
                                {/*<div className="col-md-6 col-lg-2  mb-3">
                                    <label className="catalog-label" htmlFor="p-group"><Trans>Product</Trans><span> </span><Trans>Group</Trans></label>
                                    <input type="text" maxLength={12}  className="form-control" id="p-group" name="ProductGroup" value={this.state.ProductGroup} onChange={e => this.onChangeInput(e, "ProductGroup")} />
                                </div>*/}
                                <div className="col-md-6 col-lg-4  mb-3">
                                    <label className="catalog-label hint-label mandatory" htmlFor="descr"><Trans>Description</Trans></label><span className="info-container">
                                        <img className="info-searchpage mb-1" src="Images/info-icon.png" />

                                        <span className="info-content info-position"><Trans>Note - all request for all item description modifications will be forwarded to the SDI  Catalog Department for review</Trans></span>
                                    </span>
                                    {/* Regression Bug - 5472 - The Description and the notes length should be 254 - K. Surya */}
                                    <textarea maxLength={254} className="form-control" id="descr" rows={3} name="Description" value={this.state.Description} onChange={e => this.onChangeInputDescription(e, "Description")} />
                                    {this.state.ErrDes ? <span className="errorfloat-left err-msg text-danger" style={{ fontSize: '10px' }}><Trans>Enter</Trans><span> </span><Trans>Description</Trans></span> : null}
                                </div>
                                <div className="col-md-6 col-lg-4  mb-3">
                                    <label className="catalog-label hint-label" htmlFor="notes"><Trans>Notes</Trans></label><span className="info-container ml-1">
                                        <img className="info-searchpage mb-1" src="Images/info-icon.png" />
                                        <span className="info-content info-position"><Trans>Note - all text that is entered below will be  printed on the SDI PO to the supplier</Trans></span>
                                    </span>
                                    {/* Regression Bug - 5472 - The Description and the notes length should be 254 - K. Surya */}
                                    <textarea maxLength={254} className="form-control" id="notes" rows={3} name="Notes" value={this.state.Notes} onChange={e => this.onChangeInput(e, "Notes")} />
                                </div>
                                <div className="col-md-6 col-lg-2  mb-3">
                                    <label className="w-100 catalog-label hint-label mandatory"><Trans>Manufacturer</Trans></label>
                                    {/*<input type="text" className="form-control" id="Mfg" name="Mfg" maxLength={30} value={this.state.SelectedManufacturer} onChange={e => this.onChangeInputManugacturer(e, "SelectedManufacturer")} />*/}
                                    {/* <WindowedSelect
                                        className="DropDown-Font-Size"
                                        options={this.state.Manufacturer}
                                        value={this.state.SelectedManufacturer}
                                        onChange={e => this.onChangeInput(e, "SelectedManufacturer")}
                                        DownChevron={false}
                                        name="Category"
                                    />*/}
                                    {/* <Autosuggest
                                        suggestions={this.state.MfgSuggestions}
                                        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                                        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                                        getSuggestionValue={this.getSuggestionValue}
                                        renderSuggestion={this.renderSuggestion}
                                        inputProps={inputProps}
                                    />*/}
                                    <div className="search-autocomplete"  >
                                        <Autocomplete
                                            id="mfgid"
                                            getItemValue={this.getItemValue}
                                            items={this.state.Suggestion}
                                            renderItem={this.renderItem}
                                            value={this.state.SelectedManufacturer}
                                            onChange={e => this.OnChangeMfg(e)}
                                            onSelect={e => this.onSelect(e)}
                                            open={this.state.focus}
                                            inputProps={{ className: "form-control float-left pr-5 input-padding", onKeyDown: this.AnykeyPress, onBlur: this.onfocusloose, onClick: this.onclickmfg, maxLength: '50' }}
                                            maxLength="40"

                                            menuStyle={{ fontSize: '80%', position: 'absolute', maxHeight: '200px', overflow: 'auto', borderRadius: '3px', zIndex: '9999', top: '80px', left: '15px', boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)', }}
                                        />
                                        <span className={this.state.SelectedManufacturer.trim().length > 0 ? "search-cancel-header cursor-pointer" : "d-none"} style={{ cursor: 'pointer', right: '50px', top: '40px' }} onClick={() => this.clearSearch()}></span>
                                        <div className="input-group-append menu-search-group" style={{ cursor: 'pointer', right: '17px', top: '31px' }}>
                                            <span className="input-group-text">
                                                <span className="shopping-search-icon" onClick={(e) => this.validateMfg()} />
                                            </span>
                                            </div>
                                        {/*  <span className={this.state.SelectedManufacturer.trim().length > 0 ? "search-cancel-header cursor-pointer" : "d-none"} onClick={() => this.clearSearch()}></span>
                                        <span className="dropdown-search-icon" style={{ cursor: 'pointer', right: '36px', top: '40px' }}onClick={(e) => this.validateMfg()} />*/}
                                    </div>
                                    {/*<div className="input-group-append" >
                                        <span className="input-group-text" onClick={(e) => this.validateMfg()} >
                                            <span className="shopping-search-icon" />
                                        </span>
                                    </div>*/}
                                    {this.state.ErrMfg ? <span className=" float-left err-msg text-danger" style={{ fontSize: '10px' }}><Trans>Enter</Trans><span> valid </span><Trans>Manufacturer</Trans></span> : null}
                                </div>
                                <div className="col-md-6 col-lg-2  mb-3">
                                    <label className="catalog-label hint-label mandatory" htmlFor="MfgPart"><span> Mfg </span><Trans>part number</Trans></label>
                                    <input type="text" maxLength={35} className="form-control" id="MfgPart" name="MfgPart" value={this.state.MfgPart} onChange={e => this.onChangeInputMFGPart(e, "MfgPart")} />
                                    {this.state.ErrMfgPart ? <span className="float-left err-msg text-danger" style={{ fontSize: '10px' }}><Trans>Enter</Trans><span> Mfg </span><Trans>part number</Trans></span> : null}
                                </div>
                                <div className="col-md-6 col-lg-2   mb-3 ">
                                    <label className="catalog-label hint-label mandatory" htmlFor="min-qty"><Trans>Min Quantity on Hand</Trans></label>
                                    <input type="text" maxLength="10" className="form-control" id="min-qty" name="MinQtyOnHand" value={this.state.MinQtyOnHand} onChange={e => this.onChangeInput(e, "MinQtyOnHand")} />
                                    {this.state.ErrMinQH ? <span className="float-left err-msg text-danger" style={{ fontSize: '10px' }}><Trans>Enter</Trans><span>  </span><Trans>min quantity on hand</Trans></span> : null}
                                </div>
                                <div className="col-md-6 col-lg-2  mb-3">
                                    <label className="catalog-label hint-label mandatory" htmlFor="max-qty"><Trans>Max Quantity on Hand</Trans></label>
                                    <input type="text" maxLength="10" className="form-control" id="max-qty" name="MaxQty" value={this.state.MaxQty} onChange={e => this.onChangeInput(e, "MaxQty")} />
                                    {this.state.ErrMaxQty ? <span className="float-left err-msg text-danger" style={{ fontSize: '10px' }}><Trans>Enter</Trans><span>  </span><Trans>max quantity on hand</Trans></span> : null}
                                </div>


                                {/**<div className="col-md-6 col-lg-2  mb-3">
                                    <label className="w-100 catalog-label"><Trans>Issue</Trans><span> </span><Trans>Charge</Trans><span> </span><Trans>Code</Trans></label>
                                    <Select
                                        className="DropDown-Font-Size"
                                        options={this.state.ChargeCD}
                                        value={this.state.SelectedChargCD}
                                        onChange={e => this.onChangeInput(e,"SelectedChargCD")}
                                        name="EmpId"
                                    />
                                </div>*/}{/*WW-241 (11/24/2021)***/}
                                <div className="col-md-6 col-lg-4  mb-3">
                                    <label className="w-100 catalog-label mandatory">Employee ID</label>
                                    <Select
                                        className="DropDown-Font-Size"
                                        options={this.state.EmpId}
                                        value={this.state.SelectedEmpId}
                                        onChange={e => this.onChangeInputEmpId(e, "SelectedEmpId")}
                                        name="EmpId"
                                    />
                                    {this.state.ErrEmpId ? <span className=" float-left err-msg text-danger" style={{ fontSize: '10px' }}><Trans>Select</Trans><span> </span><Trans>Employee</Trans><span> </span><Trans>ID</Trans></span> : null}

                                </div>

                                <div className="col-md-6 col-lg-2   mb-3 ">
                                    <div className="col-12 p-0 float-left mt-4">
                                        <div className="custom-control custom-checkbox  mt-0 item-custom-control ml-0 float-left">
                                            <input type="checkbox" className="custom-control-input" id="replenish" name="Replenish" checked={this.state.Replenish} onChange={e => this.onChangeInput(e, "Replenish")} />
                                            <label className="custom-control-label" htmlFor="replenish" />
                                        </div>
                                        <label className="catalog-label float-left ml-1 space-check " htmlFor="replenishchk"><Trans>Replenish</Trans></label>
                                    </div>
                                </div>{/**WW-328_PC_02 Add STK Items – Need to add Critical Spare Check Box (1/13/ 2022) -Aparna*/}
                                <div className="col-md-6 col-lg-2   mb-3 ">
                                    <div className="col-12 p-0 float-left mt-4">
                                        <div className="custom-control custom-checkbox  mt-0 item-custom-control ml-0 float-left">
                                            <input type="checkbox" className="custom-control-input" id="Critical" name="Critical" checked={this.state.CriticalSpare} onChange={e => this.onChangeInput(e, "CriticalSpare")} />
                                            <label className="custom-control-label" htmlFor="Critical" />
                                        </div>
                                        <label className="catalog-label float-left ml-1 space-check " htmlFor="Criticalchk"><Trans>Critical Spare</Trans></label>
                                    </div>
                                </div>
                                {/* <div className="col-md-6 col-lg-2  mb-3">
                                    <label className="catalog-label" htmlFor="f-code"><Trans>First</Trans><span> </span><Trans>Charge</Trans><span> </span><Trans>Code</Trans></label>
                                    <input type="text" maxLength={40}  className="form-control" id="f-code" name="FirstChargeCD" value={this.state.FirstChargeCD} onChange={e => this.onChangeInput(e, "FirstChargeCD")} />
                                </div>*/}
                                {/*<div className="col-md-6 col-lg-2   mb-3">
                                    <label className="w-100 catalog-label"><Trans>Hazard</Trans><span> </span><Trans>Code</Trans></label>
                                    <Select
                                        className="DropDown-Font-Size"
                                        options={this.state.HazardCD}
                                        value={this.state.SelectedHazardCD}
                                        onChange={e => this.onChangeInput(e,"SelectedHazardCD")}
                                        name="HazardCD"
                                    />
                                </div>*/}
                                {/*<div className="col-md-6 col-lg-2   mb-3">
                                    <label className="catalog-label" htmlFor="etag"><Trans>Equipment Tag</Trans><span> (ETAG)</span></label>
                                    <input type="text" maxLength={40}  className="form-control" id="etag" name="ETAG" value={this.state.ETAG} onChange={e => this.onChangeInput(e, "ETAG")} />
                                </div>*/}{/*WW-241 (11/24/2021)***/}
                                {/*<div className="col-md-6 col-lg-2  mb-3">
                                    <label className="catalog-label" htmlFor="msds">MSDS</label>
                                    <input type="text" maxLength={10}  className="form-control" id="msds" name="MSDS" value={this.state.MSDS} onChange={e => this.onChangeInput(e, "MSDS")}/>
                                </div>*/}{/*WW-241 (11/24/2021)***/}
                                {/*<div className="col-md-6 col-lg-2  mb-3">
                                    <label className="catalog-label" htmlFor="pds">Purch. Dept Spec (PDS)</label>
                                    <input type="text" maxLength={40}  className="form-control" id="pds" name="PDS" value={this.state.PDS} onChange={e => this.onChangeInput(e, "PDS")} />
                                </div>*/}{/*WW-241 (11/24/2021)***/}
                                {/*<div className="col-md-6 col-lg-2  mb-3">
                                    <label className="catalog-label float-left w-100"> </label>
                                    <div className="col-12 p-0 float-left mt-3 ">
                                        <div className="custom-control custom-checkbox  mt-0 item-custom-control ml-0 float-left">
                                            <input type="checkbox" className="custom-control-input" id="inspection" name="Inceptionrequired" checked={this.state.Inceptionrequired} onChange={e => this.onChangeInput(e, "Inceptionrequired")} />
                                            <label className="custom-control-label" htmlFor="inspection" />
                                        </div>
                                        <label className="catalog-label float-left mt-1 space-check " htmlFor="inspection"><Trans>Inspection Required</Trans></label>
                                    </div>
                                </div>*/}{/*WW-241 (11/24/2021)***/}
                                {/*<div className="col-md-6 col-lg-2   mb-3">
                                    <label className="catalog-label" htmlFor="draw-code"><Trans>Drawing</Trans><span> </span><Trans>Code</Trans></label>
                                    <input type="text" maxLength={40} className="form-control" id="draw-code" name="DrawingCD" value={this.state.DrawingCD} onChange={e => this.onChangeInput(e, "DrawingCD")} />
                                </div>*/}
                                {/*<div className="col-md-6 col-lg-2  mb-3">
                                    <label className="catalog-label float-left w-100"> </label>
                                    <div className="col-12 p-0 float-left mt-3">
                                        <div className="custom-control custom-checkbox  mt-0 item-custom-control ml-0 float-left">
                                            <input type="checkbox" className="custom-control-input" id="regrind" name="Regraind" checked={this.state.Regraind} onChange={e => this.onChangeInput(e, "Regraind")} />
                                            <label className="custom-control-label" htmlFor="regrind" />
                                        </div>
                                        <label className="catalog-label float-left mt-1 space-check " htmlFor="regrind"><Trans>Regrind</Trans></label>
                                    </div>
                                </div>*/} {/*WW-241 (11/24/2021)***/}
                                {/*<div className="col-md-6 col-lg-2   mb-3">
                                    <label className="catalog-label" htmlFor="machine-no"><Trans>Machine Control Num</Trans></label>
                                    <input type="text" maxLength={20} className="form-control" id="machine-no" name="MachineCtrlNo" value={this.state.MachineCtrlNo} onChange={e => this.onChangeInput(e, "MachineCtrlNo")} />
                                </div>*/}{/*WW-241 (11/24/2021)***/}
                                {/*<div className="col-md-6 col-lg-2  mb-3 ">
                                    <label className="catalog-label float-left w-100"> </label>
                                    <div className="col-12 p-0 float-left mt-3">
                                        <div className="custom-control custom-checkbox  mt-0 item-custom-control ml-0 float-left">
                                            <input type="checkbox" className="custom-control-input" id="sort-emp" name="example1" />
                                            <label className="custom-control-label" htmlFor="sort-emp" />
                                        </div>
                                        <label className="catalog-label float-left mt-1 space-check " htmlFor="sort-emp">Sort Emp ID dropdown by Emp ID</label>
                                    </div>
                                </div>*/}
                            </div>
                        </div>

                        <div className="col-lg-12 border-bottom float-left   px-0 mt-3">
                            <div className="row mb-2  mx-0 ">
                                {/* <div className="col-md-6 col-lg-3  mb-3">
                                    <label className="w-100 catalog-label mandatory"><Trans>Noun</Trans></label>
                                    <Select
                                        className="DropDown-Font-Size"
                                        options={this.state.Noun}
                                        value={this.state.SelectedNoun}
                                        onChange={e => this.onChangeInput(e,"SelectedNoun")}
                                    />
                                    {this.state.ErrNoun ? <span className=" W-100 errorspan1" style={{ fontSize: '10px' }}><Trans>Enter</Trans><span> </span><Trans>Noun</Trans></span> : null}
                                </div>
                                <div className="col-md-6 col-lg-3   mb-3">
                                    <label className="w-100 catalog-label mandatory"><Trans>Modifier</Trans></label>
                                    <Select
                                        className="DropDown-Font-Size"
                                        options={this.state.Modifier}
                                        value={this.state.SelectedModifier}
                                        onChange={e => this.onChangeInput(e,"SelectedModifier")}
                                    />
                                    {this.state.ErrModifier ? <span className=" W-100 errorspan1" style={{ fontSize: '10px' }}><Trans>Enter</Trans><span> </span><Trans>Modifier</Trans></span> : null}
                                </div>
                                <div className="col-md-6 col-lg-3   mb-3">
                                    <label className="w-100 catalog-label mandatory"><Trans>ItemKey</Trans><span> </span><Trans>type</Trans></label>
                                    <Select
                                        className="DropDown-Font-Size"
                                        options={this.state.ItemType}
                                        value={this.state.SelectedItemType}
                                        onChange={e => this.onChangeInput(e,"SelectedItemType")}
                                    />
                                </div>*/}
                                {/* <div className="col-md-6 col-lg-3   mb-3">
                                    <label className="w-100 catalog-label mandatory"><Trans>Stock</Trans><span> </span><Trans>type</Trans></label>
                                    <Select
                                        className="DropDown-Font-Size"
                                        options={this.state.StockType}
                                        value={this.state.SelectedStockType}
                                        onChange={e => this.onChangeInput(e,"SelectedStockType")}
                                    />
                                </div>*/}
                                {/* <div className="col-md-6 col-lg-3  mb-3">
                                    <label className="catalog-label mandatory" htmlFor="std-cost"><Trans>Standard</Trans><span> </span><Trans>Cost</Trans></label>
                                    <input type="number" maxLength={8} className="form-control" id="std-cost" name="StdCD" value={this.state.StdCD} onChange={e => this.onChangeInput(e, "StdCD")} />
                                    {this.state.ErrStdCost ? <span className=" W-100 errorspan1" style={{ fontSize: '10px' }}><Trans>Enter</Trans><span> </span><Trans>Standard</Trans><span> </span><Trans>Cost</Trans></span> : null}
                                </div>
                                <div className="col-md-6 col-lg-3   mb-3">
                                    <label className="catalog-label mandatory" htmlFor="ld-time"><Trans>Lead-Time</Trans></label>
                                    <input type="number" maxLength={8} className="form-control" id="ld-time" name="LeadTime" value={this.state.LeadTime} onChange={e => this.onChangeInput(e, "LeadTime")} />
                                   
                                </div>*/} {/*WW-241 (11/24/2021)***/}
                                <div className="col-md-6 col-lg-2   mb-3">
                                    <label className="w-100 catalog-label mandatory"><Trans>Vendor</Trans><span> </span><Trans>ID</Trans></label>
                                    <WindowedSelect
                                        className="DropDown-Font-Size"
                                        options={this.state.VendorId}
                                        value={this.state.SelectedVendorId}
                                        onChange={e => this.onChangeInputVendorId(e, "SelectedVendorId")}
                                    />
                                    {this.state.ErrVendorId ? <span className=" float-left err-msg text-danger" style={{ fontSize: '10px' }}><Trans>Enter</Trans><span> </span><Trans>Vendor</Trans><span> </span><Trans>ID</Trans></span> : null}


                                </div>
                                <div className="col-md-6 col-lg-2   mb-3">
                                    <label className="catalog-label mandatory" htmlFor="v-id"><Trans>Vendor</Trans><span> </span><Trans>Item ID</Trans></label>
                                    <input type="text" maxLength={50} className="form-control" id="v-id" name="VendorItemId" value={this.state.VendorItemId} onChange={e => this.onChangeInput(e, "VendorItemId")} />
                                    {this.state.ErrVendorItemID ? <span className=" float-left err-msg text-danger" style={{ fontSize: '10px' }}><Trans>Enter</Trans><span> </span><Trans>Vendor Item</Trans><span> </span><Trans>ID</Trans></span> : null}

                                </div>
                                <div className="col-md-6 col-lg-2   mb-3 ">
                                    <div className="dollar-input">
                                        <label className="catalog-label hint-label mandatory" htmlFor="Price"><Trans>Price </Trans></label>
                                        <input type="text" className="form-control" id="Price" name="Price" value={this.state.Price} onChange={e => this.onChangeInput(e, "Price")} />
                                    </div>
                                    {this.state.ErrPrice ? <span className="float-left err-msg text-danger" style={{ fontSize: '10px' }}><Trans>Enter</Trans><span>  </span><Trans>Price</Trans></span> : null}
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12 border-bottom float-left px-0 mt-3 mb-3">
                            <div className="row mb-2  mx-0 ">
                                <div className="col-md-12   p-0">
                                    <p className="row-title px-3"><Trans>Bin</Trans><span> </span><Trans>Location</Trans></p>
                                </div>
                                <div className="col-md-6 col-lg-2   mb-3">
                                    <label className="w-100 catalog-label mandatory"><Trans>Area</Trans></label>
                                    <Select
                                        className="DropDown-Font-Size"
                                        options={this.state.Area}
                                        value={this.state.SelectedArea}
                                        onChange={(e) => this.selectAreaChange(e)}
                                        name="Area"
                                    />
                                    {this.state.ErrArea ? <span className="float-left err-msg text-danger" style={{ fontSize: '10px' }}><Trans>Enter</Trans><span> </span><Trans>Area</Trans></span> : null}
                                </div>
                                <div className="col-md-6 col-lg-2   mb-3">
                                    <label className="w-100 catalog-label mandatory"><Trans>Aisle</Trans></label>
                                    <Select
                                        className="DropDown-Font-Size"
                                        options={this.state.Aisle}
                                        value={this.state.SelectedAisle}
                                        onChange={(e) => this.selectAisleChange(e)}
                                    />
                                    {this.state.ErrAisel ? <span className="float-left err-msg text-danger" style={{ fontSize: '10px' }}><Trans>Enter</Trans><span> </span><Trans>Aisle</Trans></span> : null}
                                </div>
                                <div className="col-md-6 col-lg-2   mb-3">
                                    <label className="w-100 catalog-label mandatory"><Trans>Row</Trans></label>
                                    <Select
                                        className="DropDown-Font-Size"
                                        options={this.state.Row}
                                        value={this.state.SelectedRow}
                                        onChange={(e) => this.selectRowChange(e)}
                                    />
                                    {this.state.ErrRow ? <span className="float-left err-msg text-danger" style={{ fontSize: '10px' }}><Trans>Enter</Trans><span>  </span><Trans>Row</Trans></span> : null}

                                </div>
                                <div className="col-md-6 col-lg-2  mb-3">
                                    <label className="w-100 catalog-label mandatory"><Trans>Shelf</Trans></label>
                                    <Select
                                        className="DropDown-Font-Size"
                                        options={this.state.Shelf}
                                        value={this.state.SelectedShelf}
                                        onChange={(e) => this.selectShelfChange(e)}
                                    />
                                    {this.state.ErrShelf ? <span className=" float-left err-msg text-danger" style={{ fontSize: '10px' }}><Trans>Enter</Trans><span> </span><Trans>Shelf</Trans></span> : null}
                                </div>
                                <div className="col-md-6 col-lg-2  mb-3">
                                    <label className="w-100 catalog-label mandatory"><Trans>Bin</Trans></label>
                                    <Select
                                        className="DropDown-Font-Size"
                                        options={this.state.Bin}
                                        value={this.state.SelectedBin}
                                        onChange={(e) => this.selectBinChange(e, "SelectedBin")}
                                    />
                                    {this.state.ErrBin ? <span className="float-left err-msg text-danger" style={{ fontSize: '10px' }}><Trans>Enter</Trans><span> </span><Trans>Bin</Trans></span> : null}
                                </div>
                                {/*CPW-94_PC_06 -Aparna*/}
                                {/*<div className="col-md-6 col-lg-3  mb-3">
                                    <label class="custom-file-upload">
                                        <input type="file" title=" " accept="image/jpeg, image/png" id="AddStockAttach" name="AddStockAttach" style={{ "display": "none" }} onClick={this.onInputClick} onChange={this.handleAttachment} />
                                        Browse
                                          </label>
                                   
                                </div>
                                <div className="col-md-6 col-lg-3  mb-3">
                                    {this.bindAttachments}
                                </div>*/}

                            </div>
                        </div>
                        <div className="col-lg-12 border-bottom float-left px-0 mt-3 mb-3" >
                            <div className="row mb-2  mx-0 ">
                                <div className="col-md-12   p-0">
                                    <p className="row-title px-3"><Trans>attachment_key</Trans></p>
                                </div>
                                <div className="col-md-6 mb-4">
                                    {/* <input type="file" class="float-left col-md-7 form-control"/> */}
                                    <div className="col-md-6 custom-file mb-3 p-0" style={{ zIndex: '0' }}>
                                        <input type="file" multiple className="custom-file-input" title=" " accept="image/jpeg, image/png" id="AddStockAttach" name="AddStockAttach" onChange={this.handleAttachment} />
                                        <label className="custom-file-label" htmlFor="customFile"><Trans>ChooseFile</Trans></label>
                                        {this.bindAttachments()}

                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-12 d-flex justify-content-end">

                            {/* Regression bug - 5485 - On clicking on Cancel button should clear all the fieldds and change the name of button to clear - K. Surya  */}

                            <button className="btn btn-secondary custom-btn-secondary secondary-btn  px-4 mr-3" onClick={e => this.CancelButtonClick(e)}><Trans>Clear</Trans></button>
                            <button className="btn btn-primary custom-btn-primary primary-btn  px-4" onClick={(e) => this.SaveButtonClick(e)}><Trans>Save</Trans></button>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
export default withTranslation()(ItemMaintenanceAComponent);
